import { render } from "./CostosPersonalPorcentGroup.vue?vue&type=template&id=2cc47ee8&scoped=true"
import script from "./CostosPersonalPorcentGroup.vue?vue&type=script&lang=js"
export * from "./CostosPersonalPorcentGroup.vue?vue&type=script&lang=js"

import "./CostosPersonalPorcentGroup.vue?vue&type=style&index=0&id=2cc47ee8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cc47ee8"

export default script